/*
 * SPDX-FileCopyrightText: 2026 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { GuardResult } from '@angular/router';
import { CartValidationGuard } from '@spartacus/cart/base/core';
import { CartValidationStatusCode } from '@spartacus/cart/base/root';
import { GlobalMessageType } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class CustomCartValidationGuard extends CartValidationGuard {
  override canActivate(): Observable<GuardResult> {
    console.log('LEL');
    return !this.cartConfigService.isCartValidationEnabled()
      ? of(true)
      : this.cartValidationService.validateCart().pipe(
          withLatestFrom(this.activeCartService.getEntries()),
          map(([cartModificationList, cartEntries]) => {
            this.cartValidationStateService.updateValidationResultAndRoutingId(
              cartModificationList.cartModifications ?? [],
            );
            if (
              cartModificationList.cartModifications !== undefined &&
              cartModificationList.cartModifications.length !== 0
            ) {
              let validationResultMessage;
              const modification = cartModificationList.cartModifications[0];

              if (
                cartEntries.length === 1 &&
                cartEntries[0].product?.code === modification.entry?.product?.code &&
                modification.statusCode === CartValidationStatusCode.NO_STOCK
              ) {
                validationResultMessage = {
                  key: 'validation.cartEntryRemoved',
                  params: {
                    name: modification.entry?.product?.name,
                  },
                };
              } else {
                validationResultMessage = {
                  key: 'validation.cartEntriesChangeDuringCheckout',
                };
              }

              this.globalMessageService.add(
                validationResultMessage,
                GlobalMessageType.MSG_TYPE_ERROR,
                this.GLOBAL_MESSAGE_TIMEOUT,
              );
              this.globalMessageService.add(
                modification.statusMessage ?? '',
                GlobalMessageType.MSG_TYPE_ERROR,
                this.GLOBAL_MESSAGE_TIMEOUT,
              );
              this.activeCartService.reloadActiveCart();
              return this.router.parseUrl(this.semanticPathService.get('cart') ?? '');
            }

            return true;
          }),
        );
  }
}
